<ion-badge class="a-satus-badge" mode="ios" [color]="iconColor">
  <ion-icon class="a-satus-badge__icon" *ngIf="icon !== 'ribbon-sharp'" [name]="icon" [color]="textColor"></ion-icon>
  <ion-icon class="a-satus-badge__icon" *ngIf="icon === 'ribbon-sharp'" src="assets/ribbon.svg"></ion-icon>
    <ion-text class="a-satus-badge__text" [color]="textColor">
      {{ status | cadastroStatus }}
    </ion-text>
</ion-badge>
